module.exports = __webpack_public_path__ + "static/media/biology.c578f31b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/biology.jpg
// module id = 481
// module chunks = 0